import {IDENTITY_SERVICE, IS_DEV, LOGOUT_URL} from "@/defaults";

const TOKEN_KEY = 'act';
const ACCESS_TOKEN_KEY = 'act-bearer';
export const token = {
  Save(token) {
    document.cookie = `${TOKEN_KEY}=${token}; path=/`;
  },
  Get() {
    const cookies = document.cookie.split('; ');
    const tokenCookie = cookies.find(cookie => cookie.startsWith(`${TOKEN_KEY}=`));
    return tokenCookie ? tokenCookie.split('=')[1] : null;
  },

  GetBearer() {
    const cookies = document.cookie.split('; ');
    const tokenCookie = cookies.find(cookie => cookie.startsWith(`${TOKEN_KEY}=`));
    return tokenCookie ? tokenCookie.split('=')[1] : null;
  },

  Remove() {
    document.cookie = `${TOKEN_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  },
  GoToLogin() {
    const url = window.location.href
    if (url.includes('is_dev')) {
      return
    } else {
      // if(IS_DEV) {
      // 	window.location.href = '/auth/login'
      // } else {
      window.location.href = `${IDENTITY_SERVICE.split('?')[0]}/auth/login?returnUrl=${url}`
      // }
    }
  },
  Logout() {
    // if(IS_DEV) {
    // 	window.location.href = '/auth/login'
    // } else {
    window.location.href = LOGOUT_URL
    // }
  }
};


export function RemoveAllTokens() {
  token.Remove();
}

export default {
  token,
};



